import { render, staticRenderFns } from "./PMChartCreateEdit.vue?vue&type=template&id=0c8bcccf&"
import script from "./PMChartCreateEdit.vue?vue&type=script&lang=ts&"
export * from "./PMChartCreateEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PMChartCreateEdit.vue?vue&type=style&index=0&id=0c8bcccf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports